import {
  androidAppStoreUrl,
  iosAppStoreUrl,
} from '../../config/constants/appUrl';
import {MOBILE_OS_ANDROID, MOBILE_OS_IOS, type MobileOS} from './getMobileOS';

export function getMobileDeepLinks(mobileOS: MobileOS): string {
  switch (mobileOS) {
    case MOBILE_OS_IOS: {
      return iosAppStoreUrl;
    } // ToDo -> AppStoreUrl を AppUrlにテスト後、変更(androidAppUrl DeepLinksは一般のブラウザーではテストできず、adbと実際のandroidスマホが必要)

    case MOBILE_OS_ANDROID: {
      return androidAppStoreUrl;
    }

    default: {
      return '';
    }
  }
}
